import { ModulePackFE_FlowSheetDB, ModulePackFE_LogTemplateDB, ModulePackFE_NoteTemplateDB, ModulePackFE_SmartDocDB } from './_entity.js';
export const ModulePackFE_SmartDocs = [
    ...ModulePackFE_SmartDocDB,
    ...ModulePackFE_FlowSheetDB,
    ...ModulePackFE_NoteTemplateDB,
    ...ModulePackFE_LogTemplateDB,
];
//# sourceMappingURL=module-pack.js.map